// A data store for Smartsettle ONE data retrieved from it's 'api/v1/'

import axios from 'axios'
import { createStore } from 'vuex'
import I18n from '../utilities/translations.js.erb'

export default createStore({
  state: {
    debug: false,
    apiService: {},
    state: {
      negoDetails: {},
      errors: [],
      errorMessage: '',
      offline: false
    }
  },
  actions: {
    // ACTIONS
    async fetchData({commit, dispatch, state}, params) {
    //async fetchData(paramscaseId, mediated=false) {
      let statusSlug = 'negotiation_status'
      if (params.mediated)
        statusSlug = 'mediation_status'
      try {
        // Negotiation data
        let resp = await this.apiService.get(`negotiations/${params.caseId}/${statusSlug}`)
        //console.log("store - fetchData")
        //console.log(state);
        commit('processData', {resp: resp})
        commit('setOffline', {isOffline: false})
      } catch (error) {
        if (error.message === 'Network Error')
          commit('setOffline', true)
          //this.state.offline = true
        else
          dispatch('processError', {error: error, failedAction: I18n.t('javascript.errors.get_newest_data')})
          //this.processError(error, I18n.t('javascript.errors.get_newest_data'))
          // We don't rethrow here because we don't want to interrupt the data polling loop
          // All other methods should rethrow the error
      }
    },
    async savePosition({commit, dispatch, state}, params) {
    //async savePosition(method, value, issueId) {
      try {
        let caseId = state.state.negoDetails.id || 0
        let preppedData = await dispatch('prepareData', {method: params.method, value: params.value, issueId: params.issueId})
        let resp = await this.apiService.get(`negotiations/${caseId}/${preppedData.slug}`, {params: preppedData.data})
        commit('processData', {resp: resp})
        //this.state.state.negoDetails = this.processData(resp)
      } catch (error) {
        dispatch('processError', {error: error, failedAction: I18n.t('javascript.errors.update_' + params.method.toLowerCase())})
        throw error
      }
    },
    async allowMediatorToSeeSecret({state}) {
      try {
        let caseId = state.state.negoDetails.id || 0
        await this.apiService.get(`negotiations/${caseId}/allow_mediator_see_secret`)
      } catch (error) { throw error }
    },
    async endSession({commit, dispatch, state}, params) {
      try {
        let caseId = state.state.negoDetails.id || 0
        //let param = dispatch('prepareEndSessionParams', {secret_bid_extension: params.secret_bid_extension})
	let ps = {
        	'negotiation_id': state.state.negoDetails.id || 0,
        	'your_party_id': state.state.negoDetails?.your_party?.id || 0,
        	'extend_secret_bid': params.secret_bid_extension > 0,
        	'secret_bid_extension': params.secret_bid_extension
      	}

        let resp = await this.apiService.get(`negotiations/${caseId}/end_session`, {params: ps})
        commit('processData', {resp: resp})
      } catch (error) {
        dispatch('processError', {error: error, failedAction: I18n.t('javascript.errors.end_session')})
        throw error
      }
    },
    async declareFinalSession({commit, dispatch, state}, params) {
      try {
        let caseId = state.state.negoDetails.id || 0
        //let param = dispatch('prepareFinalSessionParams', {arbitration: params.arbitration})
	let ps = {
        	'negotiation_id': state.state.negoDetails.id || 0,
        	'your_party_id': state.state.negoDetails?.your_party?.id || 0
     	}

        let resp = await this.apiService.get(`negotiations/${caseId}/declare_final_session`, {params: ps})
        commit('processData', {resp: resp})
      } catch (error) {
        dispatch('processError', {error: error, failedAction: I18n.t('javascript.errors.declare_session_final')})
        throw error
      }
    },
    async declareAllDone({commit, dispatch, state}, params) {
      try {
        let caseId = state.state.negoDetails.id || 0
	//let param = await dispatch('prepareAllDoneParams', {arbitration: params.arbitration, secret_bid_extension: params.secret_bid_extension})
	let ps = {
        	'negotiation_id': state.state.negoDetails.id || 0,
        	'your_party_id': state.state.negoDetails?.your_party?.id || 0,
        	'arbitration_accepted': params.arbitration ? 'yes' : 'no',
        	'extend_secret_bid': params.secret_bid_extension > 0,
        	'secret_bid_extension': params.secret_bid_extension
      	}

        let resp = await this.apiService.get(`negotiations/${caseId}/declare_all_done`, {params: ps})
        commit('processData', {resp: resp})
      } catch (error) {
        dispatch('processError', {error: error, failedAction: I18n.t('javascript.errors.declare_all_done')})
        throw error
      }
    },
    async cancelEndSession({state, commit, dispatch}) {
      try {
        let caseId = state.state.negoDetails.id || 0
        let resp = await this.apiService.get(`negotiations/${caseId}/cancel_end_session`)
          
        commit('processData', {resp: resp})
      } catch (error) {
        dispatch('processError', {error: error, failedAction:  I18n.t('javascript.errors.cancel_end_session')})
        throw error
      }
    },
    async checkAgreement({state, commit, dispatch}) {
      //console.log("CheckAgreement");
      try {
        let caseId = state.state.negoDetails.id || 0
        let resp = await this.apiService.get(`negotiations/${caseId}/check_agreement`)
        commit('processData', {resp: resp})
      } catch (error) {
        //console.log(error);
        dispatch('processError', {error: error, failedAction: I18n.t('javascript.errors.check_agreement')})
        throw error
      }
    },
    async cancelAllDone({state, commit, dispatch}) {
      try {
        let caseId = state.state.negoDetails.id || 0
        let resp = await this.apiService.get(`negotiations/${caseId}/cancel_all_done`)
        commit('processData', {resp: resp})
      } catch (error) {
        dispatch('processError', {error: error, failedAction: I18n.t('javascript.errors.cancel_all_done')})
        throw error
      }
    },
    processError({dispatch, state}, params) {
    //processError(error, failedAction) {
      // This is used in all catch expressions in here
      // It should be the only code which writes to `this.state.errors`
      //
      // If the server sends some message on non 200 status code, we should include it
      console.log(params.error.name + ': ' + params.error.message)
      let failedAction = params.failedAction
      if (state.debug)
        console.log(paramserror.stack)
      dispatch('showError', {msg: I18n.t('javascript.errors.failed_to', {failedAction})})
      //this.showError(I18n.t('javascript.errors.failed_to', {failedAction}))
    },
    showError({commit, dispatch, state}, params) {
      // Just show one errorMessage at the time
      // Each message stays for 3 seconds
      // Messages are queued until it's their turn
      commit('addError', {error: params.msg})
      if (state.errorMessage === '')
        dispatch('showErrorMsg')
        //this.showErrorMsg()
    },
    prepareData({state}, params) {
    //prepareData({}, method, value, issueId) {
      // Prepare the data
      let slug = 'update_visible_proposal'
      let data = {
        'negotiation_id': state.state.negoDetails.id || 0,
        'your_party_id': state.state.negoDetails?.your_party?.id || 0,
        'issue_id': params.issueId,
      }

      // Decide which endpoint to use
      switch (params.method) {
        case 'Proposal':
          slug = 'update_visible_proposal'
          data['visible_proposal'] = params.value
          break
        case 'ProposalAndAcceptance':
          slug = 'update_acceptance_and_visible_proposal'
          data['visible_proposal'] = params.value
          break
        case 'Acceptance':
          slug = 'update_acceptance'
          data['acceptance'] = params.value
          break
        default:
          throw 'The persist method has to be one of the above e.g. "Proposal"'
      }

      return {slug, data}
    },
    prepareAllDoneParams({state}, params) {
      return {
        'negotiation_id': state.state.negoDetails.id || 0,
        'your_party_id': state.state.negoDetails?.your_party?.id || 0,
        'arbitration_accepted': params.arbitration,
        'extend_secret_bid': params.secret_bid_extension > 0,
        'secret_bid_extension': params.secret_bid_extension
      }
    },
    prepareEndSessionParams({state}, params) {
      return {
        'negotiation_id': state.state.negoDetails.id || 0,
        'your_party_id': state.state.negoDetails?.your_party?.id || 0,
        'extend_secret_bid': params.secret_bid_extension > 0,
        'secret_bid_extension': params.secret_bid_extension
      }
    },
    prepareFinalSessionParams({state}, params) {
      return {
        'negotiation_id': state.state.negoDetails.id || 0,
        'your_party_id': state.state.negoDetails?.your_party?.id || 0
      }
    },
    showErrorMsg({commit, dispatch, state}) {
      // This is a recursive method that should only be
      // called by showError()
      commit('setError', {clear: false})
      setTimeout(() => {
        commit('setError', {clear: true})
        commit('shiftError', {})
        if (state.errors.length > 0)
          dispatch('showErrorMsg')
      }, 3000)
    }
  },
  mutations: {
    //INITIALIZING
    setEndpoint(state, params) {
    //setEndpoint(endpoint, creds) {
      this.apiService = axios.create({
        baseURL: params.endpoint,
        headers: params.creds ? {
          'X-User-Email': params.creds.username,
          'X-User-Token': params.creds.apiKey,
        } : {}
      })
    },
    addError(state, params){
      state.state.errors.push(params.error)
    },
    shiftError(state, params){
      state.state.errors.shift()
    },
    setError(state, params){
      if (params.clear == false){
        state.state.errorMessage = state.errors[0]
      } else {
        state.state.errorMEssage = ''
      }
    },
    setNegoDetails(state, params){
      //console.log("store - setNegoDetails")
      //console.log(params.negoDetails)
      state.state.negoDetails = params.negoDetails
    },
    setOffline(state, params){
      state.state.offline = params.isOffline
    },
    // HELPERS
    processData(state, params) {
      // Check if it really returned the correct data
      //console.log("store - processData");
      if (params.resp.status !== 200 || params.resp.data['success'] === false) {
        let msg = 'Something unexpected happened on the server'
        if (params.resp.data['message'])
          msg = params.resp.data['message']
        throw new Error(msg)
      }
      if (!params.resp.data.negotiation?.id) {
        throw new Error('Data sent from server has incorrect format')
      }
      if (!params.resp.data.negotiation?.your_party?.id || !params.resp.data.negotiation?.other_party?.id) {
        if (!params.resp.data.negotiation?.first_party_short_name || !params.resp.data.negotiation?.second_party_short_name)
          throw new Error('Some data sent from server has incorrect format')
      }

      // Update our backend data store

      //console.log(params.resp.data['negotiation']);
      state.state.negoDetails = params.resp.data['negotiation']
        //return params.resp.data['negotiation']
    }
  }
});
